import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getEnrichedArticles } from "../../shared/utils/getArticleInformation"
import { specialOfferProjection } from "../sanity/specialOffer.projection"

export const querySpecialOffer = {
  async specialOffer(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id, loggedInBranch, customerId } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.SPECIAL_OFFERS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    //TODO: attachments and attachmentFiles are of type json response. Check what is needed and define better types
    const specialOffer = await client.fetch(
      groq`*[_type=="specialOffer" && id==$id ${draftsFilter}][0]{
        ${specialOfferProjection()}
      }`,
      { id: id },
    )
    if (specialOffer?.appliedToVariants) {
      specialOffer.appliedToVariants = await getEnrichedArticles({
        articles: specialOffer.appliedToVariants,
        branchId: loggedInBranch,
        customerId: customerId,
      })
    }
    const enrichedBundles = specialOffer?.appliedToBundles?.map(async (bundle) => {
      const enrichedVariants = await getEnrichedArticles({
        articles: bundle.variants,
        branchId: loggedInBranch,
        customerId: customerId,
      })
      return {
        ...bundle,
        variants: enrichedVariants,
      }
    })
    specialOffer.appliedToBundles = enrichedBundles ?? []
    return specialOffer ?? null
  },
}
